import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';

@Injectable()
export class AppMatPaginator implements MatPaginatorIntl {
    numberFormatter = new Intl.NumberFormat('es-HN', {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
    });

    changes = new Subject<void>();

    // For internationalization, the `$localize` function from
    // the `@angular/localize` package can be used.
    firstPageLabel = `Primera pagina`;
    itemsPerPageLabel = `Elementos`;
    lastPageLabel = `Ultima pagina`;

    // You can set labels to an arbitrary string too, or dynamically compute
    // it through other third-party internationalization libraries.
    nextPageLabel = 'Siguiente pagina';
    previousPageLabel = 'Pagina anterior';

    getRangeLabel(page: number, pageSize: number, length: number): string {
        if (length === 0) {
            return `Pagina 1 de 1`;
        }
        const amountPages = Math.ceil(length / pageSize);
        return `Pagina ${page + 1} de ${amountPages} Elementos: ${this.numberFormatter.format(length)}`;
    }
}
